<template>
    <va-edit-layout>
        <ProductAdsPaymentEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></ProductAdsPaymentEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
